var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelivered(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MC/Delivered"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000008885"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250849",
    d: "M0.959999 12.48L12 3.35999L23.04 12.48",
    stroke: "#383434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250847",
    d: "M9.6 14.4H3.36V20.16H9.6V14.4Z",
    fill: "#6BE3A2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250852",
    d: "M20.64 14.4H14.4V20.16H20.64V14.4Z",
    fill: "#6BE3A2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250851",
    d: "M3.36 11.9175V20.1594H9.49161V14.3526H14.1368V20.1594H20.64V11.9175",
    stroke: "#383434",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250850",
    d: "M15.84 6.62606V3.35999H18.24V8.63999",
    stroke: "#383434"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivered);
export default __webpack_public_path__ + "static/media/Delivered.f70019b029b395b0a0ef6d77e076071f.svg";
export { ForwardRef as ReactComponent };